import { Image } from 'expo-image';
import { useMemo } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import { ChallengeHomeCardProps } from './types';

export function ChallengeHomeCardDesktop({ challenges, style, testID }: ChallengeHomeCardProps) {
  const rows = useMemo(() => {
    const rowElements: React.ReactNode[] = [];
    for (let i = 0; i < challenges.length; i += 2) {
      const rowChallenges = challenges.slice(i, i + 2);
      rowElements.push(
        <View key={i} style={styles.row}>
          {rowChallenges.map(challenge => (
            <Pressable key={challenge.id} style={[styles.gridItem]} onPress={challenge.onPress}>
              <Image source={{ uri: challenge.image }} style={styles.image} />
            </Pressable>
          ))}
        </View>
      );
    }
    return rowElements;
  }, [challenges]);

  return (
    <View testID={testID} style={[styles.container, style]}>
      {rows}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 16,
    marginBottom: 8,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 16,
    gap: 16,
  },
  gridItem: {
    flex: 1,
    height: 127,
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
  },
});
